const schema = [
        ['user'],
        ['tenant'],
        ['role'],
];

export default schema;
